import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CAR_TYPE, GET_CAR_TYPE_SUCCESS, GET_CAR_TYPE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCarType({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/car-types`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CAR_TYPE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CAR_TYPE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CAR_TYPE_ERROR, payload: error });
  }
}

export function* watchGetCarType() {
  yield takeEvery(GET_CAR_TYPE, getCarType);
}

function* getCarTypeSaga() {
  yield all([fork(watchGetCarType)]);
}

export default getCarTypeSaga;
